import type { ScreenMode } from 'apiConnector/quote-loading';
import type { Underlying, UnderlyingAssetType } from 'models/underlying';
import type { UnderlyingStrike } from 'models/underlying/base';

export enum UnderlyingStrikeRestriction {
  NoRestriction = 'NoRestriction',
  RestrictStrikeValue = 'RestrictStrikeValue',
  RestrictStrikeDate = 'RestrictStrikeDate',
  RestrictAll = 'RestrictAll',
}

export interface IUnderlying {
  areaEligibility?: string[];
  asset: UnderlyingAssetType;
  bloombergTickerCode: string;
  calendar?: ICalendar;
  compositeId: string;
  currency: string;
  eliotCode?: string;
  exchange: string;
  extendedMarketOffset: number;
  id: string;
  idType: 'Bloomberg' | 'CurveName' | 'PrimaryRootName' | 'Eliot';
  isin: string;
  isRestricted?: boolean;
  hasMissingCodes?: boolean;
  name: string;
  rating?: string;
  reutersCode: string;
  seniorityType?: string;
  spotReference?: number;
  strike?: UnderlyingStrike;
  tradeEndTime?: Date;
  transactionType?: string;
  type: string;
  valorCode?: string;
  website: string;
  weight?: number;
}

export interface ICalendar {
  calendarType: string;
  currency: string;
  id: string;
}

export interface IUnderlyingSearchResult {
  underlyings: IUnderlying[];
  underlyingType: string;
}

export interface IUnderlyingUniverse {
  equityUnderlyings: IUnderlying[];
  commodityUnderlyings: IUnderlying[];
  creditUnderlyings: IUnderlying[];
  hasEquityAuthorization: boolean;
  hasCommodityAuthorization: boolean;
  hasCreditAuthorization: boolean;
}

export interface IUnderlyingRequest {
  instrumentName?: string;
  instrumentContractName?: string;
  productType?: string;
  productSubtype?: string;
  underlyingBlock?: string;
  wrapper?: string;
  clientId?: string;
  basketUnderlyingIds?: string[];
  basketUnderlyings?: ReadonlyArray<Underlying>;
  screenMode?: ScreenMode;
}

export interface IUnderlyingFilterOptions extends IUnderlyingRequest {
  query: string;
}

export interface IUnderlyingDetailsOption extends IUnderlyingRequest {
  underlyingsIds?: string[];
}
